// Утилиты для оценки размеров файлов

export class SizeEstimator {
    /**
     * Оценка размера видео на основе разрешения и длительности
     * @param {number} width - ширина видео
     * @param {number} height - высота видео
     * @param {number} duration - длительность в секундах
     * @returns {number} - размер в байтах
     */
    estimateVideoSize(width, height, duration) {
        // Более реалистичная оценка размера видео в байтах
        // Используем битрейт на основе разрешения и длительности
        let bitrateKbps;
        
        if (width <= 480) {
            bitrateKbps = 500; // 480p: ~500 kbps
        } else if (width <= 720) {
            bitrateKbps = 1000; // 720p: ~1 Mbps
        } else if (width <= 1080) {
            bitrateKbps = 2000; // 1080p: ~2 Mbps
        } else {
            bitrateKbps = 4000; // 4K+: ~4 Mbps
        }
        
        // Размер = битрейт * длительность / 8 (биты в байты)
        const estimatedBytes = Math.round((bitrateKbps * 1000 * duration) / 8);
        
        // Ограничиваем максимальный размер (например, 50MB)
        const maxSize = 50 * 1024 * 1024;
        return Math.min(Math.max(estimatedBytes, 10000), maxSize);
    }

    /**
     * Оценка размера изображения на основе его размеров
     * @param {number} width - ширина изображения
     * @param {number} height - высота изображения
     * @returns {number} - размер в байтах
     */
    estimateImageSize(width, height) {
        // Примерная оценка размера в байтах для JPEG с качеством 0.8
        // Формула: width * height * 3 (RGB) * 0.8 (сжатие) * 0.5 (дополнительное сжатие)
        const estimatedBytes = Math.round(width * height * 3 * 0.8 * 0.5);
        return Math.max(estimatedBytes, 1000); // Минимум 1KB
    }

    /**
     * Получение реального размера видео через HEAD запрос
     * @param {string} videoUrl - URL видео
     * @returns {Promise<number|null>} - размер в байтах или null
     */
    async getVideoSize(videoUrl) {
        try {
            const response = await fetch(videoUrl, { method: 'HEAD' });
            const contentLength = response.headers.get('content-length');
            if (contentLength) {
                return parseInt(contentLength, 10);
            }
        } catch (error) {
            // Не удалось получить размер
        }
        return null;
    }

    /**
     * Форматирование размера в читаемый вид
     * @param {number} bytes - размер в байтах
     * @returns {string} - отформатированная строка
     */
    formatSize(bytes) {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }
}
